import { saveAs } from "file-saver";
import { type DownloadBillArgsT } from "./types";
import Axios from "axios";
import CONFIG from "../../model/TSConfig";
import { HEADER_TOKEN } from "../../utils/constants";
import BillJavaScriptDTO from "@tootsweet/model/datatransfer/BillDTO";
import { tt } from "../../utils/i18n/i18n";
import CurrencySubUnitsMap from "../../model/CurrencySubUnitsMap";
import { AxiosForLegacyBackend } from "../../utils/helpers/AxiosForLegacyBackend";

export async function fetchBillData(
  billId: string,
  responseType?: XMLHttpRequestResponseType,
  token?: string
) {
  if (!token) return null;
  const { data } = await Axios({
    method: "GET",
    url: `${CONFIG.backendURL}/billing/downloadBill`,
    params: { id: billId },
    responseType: responseType || "blob",
    headers: {
      [HEADER_TOKEN]: token
    }
  });
  return data;
}

export const downloadBill = async ({
  billId,
  billNumber,
  monthAndYear,
  token
}: DownloadBillArgsT) => {
  const data = await fetchBillData(billId, "blob", token);
  const blob = new Blob([data], { type: "application/pdf" });
  const filename = `KadowCub_${tt("bill_filename")}_${monthAndYear}-${billNumber}`;
  saveAs(blob, filename);
};

export const fetchBills = async (
  token: string | undefined
): Promise<{
  currencySubUnits: CurrencySubUnitsMap;
  subscription: BillJavaScriptDTO[];
  manual: BillJavaScriptDTO[];
} | null> => {
  if (!token) {
    return null;
  }
  const { data } = await Axios({
    method: "GET",
    url: `${CONFIG.saasBackendUrl}/subscription/bills`,
    headers: { Authorization: `Bearer ${token}` }
  });
  return data;
};

export const payBill = async (
  billId: string,
  businessUserId: string,
  cardId: string
): Promise<{
  clientSecret: string;
  paymentIntentId: string;
} | null> => {
  const { data } = await AxiosForLegacyBackend({
    method: "POST",
    url: `${CONFIG.backendURL}/payment/payBill`,
    params: {
      billId,
      businessUserId,
      cardId
    }
  });
  return data;
};
